export default __webpack_public_path__ + "static/media/ITR-5.e8fc5252.png";